<div [ngStyle]="style" [ngClass]="'ui-chkbox ui-widget'" [class]="styleClass">
  <div class="ui-helper-hidden-accessible">
    <input
      #cb
      type="checkbox"
      [attr.id]="inputId"
      [name]="name"
      [value]="value"
      [checked]="checked"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      [ngClass]="{ 'ui-state-focus': focused }"
      (change)="handleChange($event)"
      [disabled]="disabled"
      [attr.tabindex]="tabindex"
    />
  </div>
  <div
    class="ui-chkbox-box ui-widget ui-corner-all ui-state-default"
    (click)="onClick($event, cb, true)"
    [ngClass]="{
      'ui-state-active': checked,
      'ui-state-disabled': disabled,
      'ui-state-focus': focused,
    }"
  >
    <span class="ui-chkbox-icon ui-clickable" [ngClass]="{ 'fmi fmi-check': checked }"></span>
  </div>
</div>
<span
  class="ui-chkbox-label"
  (click)="onClick($event, cb, true)"
  [ngClass]="{
    'ui-label-active': checked,
    'ui-label-disabled': disabled,
    'ui-label-focus': focused,
  }"
  *ngIf="label"
  [attr.for]="inputId"
  >{{ label }}</span
>
